
export const personal = {
  name: "Bikash Kattel",
  nickname: "Vicky",
  tagline: "CSIT Student & Developer",
  location: "Kathmandu, Nepal",
  university: "Tribhuvan University",
  degree: "B.Sc. CSIT",
  year: " 2022 Present",
  email: "bikashkattel7@gmail.com",
  github: "https://github.com/vickyjii774",
  linkedin: "https://www.linkedin.com/in/bikash-kattel/",
  youtube: "www.youtube.com/@bikashkattel",

  bio: [
    "Hey! I'm Bikash (Vicky), a CSIT Student who loves turning ideas into impact. I enjoy the journey — from brainstorming creative solutions to  shipping something.",
       "Currently, I am focused on web development, continuously refining my skills, and building elegant, user-friendly applications that make an impact."
,
  ],
  
  interests: ["Explorer","Developing Strategies into Innovative Concept", "Sports Enthusiast", "Building Connection" ],
};

export const skills = [
  { name: "C / C++",       level: 75, category: "Languages" },
  { name: "Python",         level: 55, category: "Languages" },
  { name: "Java",           level: 45, category: "Languages" },
  { name: "JavaScript",     level: 65, category: "Languages" },

  { name: "HTML ",     level: 85, category: "Web" },
  { name: "CSS ",     level: 75, category: "Web" },
  { name: "React.js",       level: 63, category: "Web" },
  { name: "Tailwind CSS",   level: 60, category: "Web" },
  { name: "Node.js",        level: 40, category: "Web" },
  { name: "PHP",            level: 69, category: "Web" },
    { name: "Django",          level: 60, category: "Web" },


  { name: "Statistics",    level: 75, category: "Database & Tools" },
  { name: "Figma",   level: 55, category: "Database & Tools" },
  { name: "MySQL",          level: 70, category: "Database & Tools" },
  { name: "MongoDB",        level: 50, category: "Database & Tools" },
  { name: "Git & GitHub",   level: 65, category: "Database & Tools" },

];

// Status: "done" | "wip" | "planned"
export const projects = [

{
  title: "Rural Resource Allocation Management System",
  desc: "A production-ready web application for optimally allocating educational resources to rural schools in Nepal. It uses MCDA (Multi-Criteria Decision Analysis) to rank schools based on deprivation level and a Greedy Algorithm to fairly allocate budgets while respecting defined constraints.",
  tags: ["React", "Django", "JavaScript", "Python"],
  status: "done",
  github: "https://github.com/vickyjii774/ruralresource",
  live: null,
},

  
  {
    title: "BizSewa — Digital Business Renewal",
    desc: "A full-stack digital business renewal system with separate frontend and backend. Built with JavaScript and CSS to streamline business registration and renewal workflows.",
    tags: ["JavaScript", "CSS", "HTML", "Full Stack"],
    status: "done",
    github: "https://github.com/vickyjii774/bizsewaa",
    live: "https://bizsewaa.vercel.app/",
    
  },
   {
    title: "Watchy",
    desc: "A Ecommercal website built with JavaScript, PHP, CSS, and HTML. It features a user-friendly interface for browsing and purchasing watches, along with a secure backend for managing products and orders.",
    tags: ["JavaScript","PHP", "CSS", "HTML", "Full Stack"],
    status: "done",
    github: "https://github.com/vickyjii774/Ecommercewatch",
    live: "https://watchy.infinityfreeapp.com/home.php",
    
  },

  {
    title: "Stopwatch App",
    desc: "A clean, functional stopwatch built with vanilla HTML, CSS and JavaScript. Supports start, stop, and reset with accurate timing logic.",
    tags: ["HTML", "JavaScript", "CSS"],
    status: "done",
    github: "https://github.com/vickyjii774/stopwatch",
    live: null,
    
  },
 

{
  title: "Petzy",
  desc: "A pet shop e-commerce website built with React, JavaScript, HTML, and CSS, where users can browse and purchase a variety of food and essential items for their pets through a simple and user-friendly interface.",
  tags: ["React", "JavaScript", "HTML", "CSS", "E-Commerce"],
  status: "done",
  github: "https://github.com/vickyjii774/petzyy",
  live: "https://petzyy.vercel.app/",
},

  {
    title: "PHP Web Project",
    desc: "A PHP-based web application.",
    tags: ["PHP", "Web"],
    status: "done",
    github: "https://github.com/vickyjii774/project",
    live: null,
   
  },
  


{
  title: "Sugandhika",
  desc: "Pure Eco-Friendly Fragrance & Organic Mosquito Solutions ",
  tags: ["React", "TypeScript", "JavaScript"],
  status: "wip",
  github: "h",
  live: null,
},
  


];

export const education = [
  {
    degree: "B.Sc. CSIT",
    school: "Tribhuvan University",
    period: "2022 – Present",
    note: "Focused on Algorithms, OS, Networking, Stats and Software engineering.",
  },

  {
    degree: "+2 Science ",
    school: "REHDON College",
    period: "2020 – 2022",
    note: "Completed higher secondary with Physics, Chemistry,Biology and Maths.",
  },
];
